import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { BillType } from '@features/bills/enums/billType'

import { BillsTableRow } from '../../types/billsTableRow'

interface BillsTableTypeCellProps {
  row: BillsTableRow
}

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const BillsTableTypeCell = ({ row }: BillsTableTypeCellProps): ReactElement => {
  if (row.isEInvoice) {
    return <Typography.Text>E-invoice</Typography.Text>
  }

  return <Typography.Text>{row.type === BillType.Bill ? 'Invoice' : 'Credit note'}</Typography.Text>
}
